import React, { useEffect, useState, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/i18n";
import { useCart } from "@/context/CartContext";
import api from "@/lib/api";

export default function PaymentSuccess() {
  const { t } = useI18n();
  const [params] = useSearchParams();
  const { clear } = useCart();
  const [status, setStatus] = useState("checking");
  const attempts = useRef(0);
  const cleared = useRef(false);

  useEffect(() => {
    const sessionId = params.get("session_id");
    if (!sessionId) { setStatus("error"); return; }
    let timer;
    const poll = async () => {
      if (attempts.current >= 8) { setStatus("timeout"); return; }
      attempts.current += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          if (!cleared.current) { clear(); cleared.current = true; }
          return;
        }
        if (data.status === "expired" || data.payment_status === "failed") { setStatus("error"); return; }
      } catch { /* keep polling */ }
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [params]); // eslint-disable-line

  return (
    <div className="min-h-[60vh] flex items-center justify-center bg-th-blue th-pattern px-4 py-20">
      <div className="max-w-md text-center bg-white rounded-2xl p-10 shadow-2xl" data-testid="payment-result">
        {status === "checking" && <><Loader2 className="w-14 h-14 text-th-blue mx-auto animate-spin" /><h1 className="mt-5 font-display font-bold text-2xl text-th-blue">{t("payment_processing")}</h1></>}
        {status === "paid" && <><CheckCircle2 className="w-16 h-16 text-green-600 mx-auto" /><h1 className="mt-5 font-display font-bold text-2xl text-th-blue">{t("payment_success")}</h1><p className="mt-3 text-slate-600">{t("payment_thanks")}</p></>}
        {(status === "error" || status === "timeout") && <><XCircle className="w-16 h-16 text-red-500 mx-auto" /><h1 className="mt-5 font-display font-bold text-2xl text-th-blue">{t("payment_processing")}</h1></>}
        <Link to="/loja"><Button className="mt-6 bg-th-blue text-white" data-testid="payment-continue">{t("continue_shopping")}</Button></Link>
      </div>
    </div>
  );
}
